module.exports = __webpack_public_path__ + "assets/mastercard-w.002404d9.png";